module.exports = __webpack_public_path__ + "img/Industrial park.2904f3a1.png";